angular.module("circulationDomModule",[]).directive('foreach',function(){
	return{
		restrict:"A",
		compile:function(el,attrs,transclude){
			var tpl = el.children().clone();
			for(var i=0;i<attrs.foreach-1;i++){
				 el.append(tpl.clone());
			}
			return function(scope,el,attrs,controller){
			}
		}
	}
});